var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuluFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 52.662,
    viewBox: "0 0 180 52.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#040405}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "TULU_logo",
    "data-name": "TULU logo",
    transform: "translate(-2205.058 -904.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(2205.058 904.725)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(61.656 21.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4363",
    "data-name": "Path 4363",
    className: "cls-1",
    d: "M2312.5 941.6h22.245v2.639h-9.677v26.681h-2.89v-26.685h-9.678z",
    transform: "translate(-2312.499 -941.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4364",
    "data-name": "Path 4364",
    className: "cls-1",
    d: "M2372.3 966.06a10.445 10.445 0 0 0 13.594 0 9.71 9.71 0 0 0 2.43-7.038V941.6h2.89v17.426q0 5.7-3.2 8.923t-8.9 3.226q-5.7 0-8.923-3.226t-3.226-8.923V941.6h2.89v17.426a9.658 9.658 0 0 0 2.445 7.034z",
    transform: "translate(-2335.705 -941.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4365",
    "data-name": "Path 4365",
    className: "cls-1",
    d: "M2432.146 941.669h2.891v26.685h12.9v2.6h-15.793z",
    transform: "translate(-2363.486 -941.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4366",
    "data-name": "Path 4366",
    className: "cls-1",
    d: "M2481.8 966.06a10.446 10.446 0 0 0 13.594 0 9.708 9.708 0 0 0 2.43-7.038V941.6h2.89v17.426q0 5.7-3.205 8.923t-8.9 3.226q-5.7 0-8.923-3.226t-3.226-8.923V941.6h2.89v17.426a9.658 9.658 0 0 0 2.45 7.034z",
    transform: "translate(-2382.367 -941.596)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(14.266 18.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4367",
    "data-name": "Path 4367",
    d: "M2239.623 961.129a13.52 13.52 0 0 1-9.706-4.066l1.7-1.674A11.232 11.232 0 1 0 2247.5 939.5l1.673-1.7a13.617 13.617 0 0 1-9.55 23.326z",
    transform: "translate(-2229.917 -937.803)",
    style: {
      fill: "#c80045"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(5.615 10.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4368",
    "data-name": "Path 4368",
    className: "cls-1",
    d: "M2233.2 960.087a19.038 19.038 0 0 1-18.357-14.05l2.3-.621a16.628 16.628 0 1 0 20.336-20.409l.614-2.306a19.014 19.014 0 0 1-4.9 37.385z",
    transform: "translate(-2214.843 -922.702)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    transform: "translate(0 4.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4369",
    "data-name": "Path 4369",
    className: "cls-1",
    d: "M2229.03 960.891a24 24 0 0 1-23.972-23.971h2.386a21.56 21.56 0 1 0 16.121-20.888l-.6-2.309a23.974 23.974 0 1 1 6.067 47.168z",
    transform: "translate(-2205.058 -912.949)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    transform: "translate(23.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4370",
    "data-name": "Path 4370",
    className: "cls-1",
    d: "M2272.3 926.811a26.3 26.3 0 0 0-25.47-19.7v-2.385a28.681 28.681 0 0 1 27.78 21.489z",
    transform: "translate(-2246.831 -904.725)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuluFooter);
export default __webpack_public_path__ + "static/media/TuluFooter.d4ecc040484933e464ba19e90b1b1ad8.svg";
export { ForwardRef as ReactComponent };